import { useState, useRef } from 'react';
import {
  MenuItem,
  IconButton,
  Paper,
  Popper,
  MenuList,
  ClickAwayListener,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import * as Constants from '../data/Constants';
import { useNavigate } from 'react-router';

import type { IUserPanelProps } from '../../types';
/**
 * Renders the user name and a menu to logout
 * @param {IUserPanelProps} props the properties for the user panel component
 * @returns {JSX.Element} the user panel
 */
export const UserPanel = ({ user }: IUserPanelProps) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [arrowRef, setArrowRef] = useState(null);
  const open = Boolean(anchorElement);

  const navigate = useNavigate();
  const onToggleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };

  const onInternalLogout = () => {
    setAnchorElement(null);
    navigate('/logout', { replace: true });
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };
  return (
    <>
      <button className="btn-plain white-color" onClick={onToggleMenu} aria-label="user-name">
        {user}
      </button>
      <IconButton ref={anchorRef} onClick={handleClick} className="userPanelIconButton">
        <AccountCircleIcon className="userProfileIcon" />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorElement}
        placement="bottom"
        role="tooltip"
        className="zindex-100"
        modifiers={[
          ...Constants.popperModifier,
          {
            name: 'arrow',
            enabled: true,
            options: {
              element: arrowRef,
            },
          },
        ]}
      >
        <div role="tooltip">
          <Box
            component="div"
            id="arrow"
            data-popper-arrow
            className="popperStyle arrow"
            ref={setArrowRef}
          />
          <Box>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="ViewHandler-menu"
                  aria-labelledby="SwitchView-button"
                >
                  <MenuItem className="panelLogout" onClick={onInternalLogout}>
                    {t('button.logout')}
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Box>
        </div>
      </Popper>
    </>
  );
};
